import Seo from "../components/Seo";

export default function ErrorPage() {
  return (
    <>
      <Seo title="Something Went Wrong" description="An unexpected error occurred." />
      <h1>Something went wrong</h1>
      <p>
        We&rsquo;re sorry, something unexpected happened. Please try reloading the page, or{" "}
        <a href="/contact">contact us</a> if the problem continues.
      </p>
      <button type="button" className="btn btn-primary" onClick={() => window.location.assign("/")}>
        Go to home page
      </button>
    </>
  );
}
